import { SVGAttributes } from "react";

export function Logo(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.1404 6.85815H18.8583V3.42657H17.1446V1.71289H15.4268V3.42657H17.1404V6.85815Z"
        fill="currentColor"
      />
      <path
        d="M20.5723 6.85938V10.2867H18.8586V13.7141H17.1407V10.2867H13.7134V8.57306H18.8586V6.85938H20.5723Z"
        fill="currentColor"
      />
      <path
        d="M22.2864 10.2871H20.5728V12.0008H22.2864V10.2871Z"
        fill="currentColor"
      />
      <path
        d="M23.9998 12H22.2861V18.8589H23.9998V12Z"
        fill="currentColor"
      />
      <path
        d="M20.5721 20.5731H18.8584V22.2867H20.5721H22.2857V20.5731V18.8594H20.5721V20.5731Z"
        fill="currentColor"
      />
      <path
        d="M18.8544 22.2871H13.7134V24.0008H18.8544V22.2871Z"
        fill="currentColor"
      />
      <path
        d="M13.7135 18.8594H10.2861V22.2867H13.7135V18.8594Z"
        fill="currentColor"
      />
      <path
        d="M17.1404 13.7145V15.4282H15.4267V18.8597H13.7131V15.4282H10.2857V18.8597H8.57207V15.4282H6.8584V13.7145H10.2857V10.2871H13.7131V13.7145H17.1404Z"
        fill="currentColor"
      />
      <path
        d="M10.2856 8.57306V10.2867H6.8583V13.7141H5.14043V10.2867H3.42676V6.85938H5.14043V8.57306H10.2856Z"
        fill="currentColor"
      />
      <path
        d="M3.42753 10.2871H1.71387V12.0008H3.42753V10.2871Z"
        fill="currentColor"
      />
      <path
        d="M1.71367 12H0V18.8589H1.71367V12Z"
        fill="currentColor"
      />
      <path
        d="M3.42753 20.5731V18.8594H1.71387V20.5731V22.2867H3.42753H5.1412V20.5731H3.42753Z"
        fill="currentColor"
      />
      <path
        d="M10.2826 22.2871H5.1416V24.0008H10.2826V22.2871Z"
        fill="currentColor"
      />
      <path
        d="M6.85527 3.42773H5.1416V6.8551H6.85527V3.42773Z"
        fill="currentColor"
      />
      <path
        d="M8.57207 1.71289H6.8584V3.42657H8.57207V1.71289Z"
        fill="currentColor"
      />
      <path
        d="M15.4321 0H8.57324V1.71368H15.4321V0Z"
        fill="currentColor"
      />
    </svg>
  );
}